/* Nancy Universe — Main JS */
console.log('[NANCY-DEBUG] nancy-main.js v5 loaded');

(function() {
  function revealVisible() {
    var els = document.querySelectorAll('.nancy-reveal:not(.visible)');
    var vh = window.innerHeight;
    els.forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < vh + 400 && rect.bottom > -400) {
        el.classList.add('visible');
        console.log('[NANCY-DEBUG] revealed:', el.className);
      }
    });
  }

  setTimeout(function() { console.log('[NANCY-DEBUG] 100ms scan'); revealVisible(); }, 100);
  setTimeout(function() { console.log('[NANCY-DEBUG] 500ms scan'); revealVisible(); }, 500);
  setTimeout(function() { console.log('[NANCY-DEBUG] 1500ms scan'); revealVisible(); }, 1500);
  setTimeout(function() { console.log('[NANCY-DEBUG] 3000ms scan'); revealVisible(); }, 3000);

  window.addEventListener('scroll', revealVisible, { passive: true });
  var polls = 0;
  var poll = setInterval(function() {
    revealVisible();
    polls++;
    if (polls > 20) clearInterval(poll);
  }, 500);
})();
